import * as React from 'react'
import styled from 'styled-components'
import { NewsCardItemLoading } from '../screen/menus/News/NewsCardList/NewsCardItem'

const NewsCardListLoading: React.FC = () => {
  return (
    <StyledWrapper>
      <div className="hr" />
      <NewsCardItemLoading />
      <NewsCardItemLoading />
      <NewsCardItemLoading />
      <NewsCardItemLoading />
    </StyledWrapper>
  )
}

export default NewsCardListLoading

const StyledWrapper = styled.div`
  margin-bottom: 40px;
  .hr {
    height: 1px;
    background-color: #eeeeee;
  }
`
